import { Logger } from '~~/helpers/logger';
import { useUserOrderApi } from '~/utils/ct/composables/api/useUserOrderApi';
import type { ApiParams, OrderQueryResult } from '~~/types/commercetools';
import { errorToString } from '~~/helpers/error/errorToString';

export function useUserOrder() {

  const { search: apiSearch } = useUserOrderApi();
  const orders = useState<OrderQueryResult | null>('useUserOrder}', () => null);
  const loading = useState('useUserOrderLoading', () => false);
  const error = useState<{
    search: null | string
  }>('useUserOrderError', () => ({
    search: null,
  }));

  async function search(searchParams: ApiParams) {

    try {

      loading.value = true;
      orders.value = await apiSearch(searchParams);
      error.value.search = null;
    
    } catch (err: unknown) {

      error.value.search = errorToString(err);
      Logger.error('useUserOrder.search', err);
    
    } finally {

      loading.value = false;
    
    }
  
  }

  return {
    orders: computed(() => orders.value),
    search,
    loading: computed(() => loading.value),
    error: computed(() => error.value),
  };

}
